// ** React Imports
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import {
    Divider,
    TextField,
    Typography,
} from '@mui/material'
import { useNavigate, useParams } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../components/ToastProvider';
import Swal from 'sweetalert2'

export default function Index() {
    const { showToast, hideToast } = useToast();
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const [listComponent, setListComponent] = useState<any[]>([])
    const [filters, setFilters] = useState<any>({})
    const [detail, setDetail] = useState<any>(null)
    const navigate = useNavigate();


    const [listData, setListData] = useState<any[]>([])
    const {id} = useParams();
    useEffect(() => {
        getComponent()
        getDetail()
    }, [])

    const getComponent = () => {
        showToast("Loading...", "loading");
        let url = apiUrl.apiUrl + '/report/dynamic/list-component/'+id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListComponent(data)
                    hideToast();
                } else {
                    showToast(response.data.message, "success");
                }
            })
    }
    const getDetail = () => {
        let url = apiUrl.apiUrl + '/report/dynamic/detail/'+id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setDetail(data)
                    console.log(data);
                } else {
                    showToast(response.data.message, "success");
                }
            })
    }

    const searchData = () => {

        showToast("Loading...", "loading")

        let url = apiUrl.apiUrl + '/report/dynamic/list-data/' + id

        axios.get(url, {
            params: filters,
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(response => {

            if (response.data.success) {
                setListData(response.data.data)
                hideToast()
            } else {
                showToast(response.data.message, "error")
            }

        })
    }

    const handleFilterChange = (param: string, value: any) => {
        setFilters((prev: any) => ({
            ...prev,
            [param]: value
        }))
    }
    
    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            px: 2,
                            py: 1
                        }}
                        >
                        {/* Title Section */}
                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            {detail?.title}
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                            {detail?.desc}
                            </Typography>
                        </Box>

                        {/* Button Section */}
                        <Box>
                            <Button
                            variant="contained"
                            color="warning"
                            startIcon={<Icon icon="mdi:arrow-left" />}
                            onClick={() => navigate(-1)}
                            >
                            Kembali
                            </Button>
                        </Box>
                        </Box>
                    <Divider />
                    <CardContent>
                        {/* FILTER PANEL */}
                        <Box
                            sx={{
                                p: 2,
                                mb: 3,
                                borderRadius: 2,
                                background: "#f8fafc",
                                border: "1px solid #e5e7eb"
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                sx={{ mb: 2, fontWeight: 600 }}
                            >
                                Filter Report
                            </Typography>

                            <Grid container spacing={2}>
                                {listComponent.map((comp, i) => {

                                    if (comp.jenis === "textfield") {
                                        return (
                                            <Grid item xs={12} md={comp.col} key={i}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label={comp.label}
                                                    value={filters[comp.param] || ""}
                                                    onChange={(e) =>
                                                        handleFilterChange(comp.param, e.target.value)
                                                    }
                                                />
                                            </Grid>
                                        )
                                    }

                                    return null
                                })}

                                {/* ACTION BUTTON */}
                                <Grid item xs={12}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: 2,
                                            justifyContent: "flex-end",
                                            mt: 1
                                        }}
                                    >
                                        <Button
                                            variant="outlined"
                                            startIcon={<Icon icon="mdi:refresh" />}
                                            onClick={() => setFilters({})}
                                        >
                                            Reset
                                        </Button>

                                        <Button
                                            variant="contained"
                                            startIcon={<Icon icon="mdi:magnify" />}
                                            onClick={searchData}
                                        >
                                            Search
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>

                        {/* DATA GRID */}
                        <MsiDatagrid array={listData} />

                    </CardContent>
                </div>
            </Grid>
        </Grid>
    )
}